import ReactDOM from 'react-dom';
import AppPrivate from './App';
import { store } from 'app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';
import 'nprogress/nprogress.css';
import 'config/i18n';
import 'global.scss';
import { notification } from 'antd';
import { BrowserRouter } from 'react-router-dom';
notification.config({
  placement: 'topRight',
  duration: 3,
  maxCount: 1,
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppPrivate />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
